import React, { useState } from 'react';

export const TableGridSelector = ({ onSelect, onClose }) => {
  const [hover, setHover] = useState({ rows: 0, cols: 0 });
  const maxR = 8, maxC = 8;

  return (
    <div
      className="absolute top-full left-0 mt-1 bg-popover border rounded-lg shadow-xl p-3"
      style={{ zIndex: 99999 }}  /* Very high z-index to appear above canvas content */
      data-testid="table-grid-selector"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="text-[11px] font-medium mb-2 text-center" data-testid="table-grid-label">
        {hover.rows > 0 ? `${hover.rows} \u00d7 ${hover.cols} Table` : 'Insert Table'}
      </div>
      <div
        className="inline-grid gap-[2px]"
        style={{ gridTemplateColumns: `repeat(${maxC}, 1fr)` }}
        onMouseLeave={() => setHover({ rows: 0, cols: 0 })}
      >
        {Array.from({ length: maxR * maxC }, (_, i) => {
          const r = Math.floor(i / maxC) + 1;
          const c = (i % maxC) + 1;
          const lit = r <= hover.rows && c <= hover.cols;
          return (
            <div
              key={i}
              className={`w-5 h-5 border rounded-[3px] cursor-pointer transition-colors ${
                lit
                  ? 'bg-primary/30 border-primary'
                  : 'bg-muted/20 border-border/60 hover:border-muted-foreground/40'
              }`}
              onMouseEnter={() => setHover({ rows: r, cols: c })}
              onClick={() => onSelect(r, c)}
              data-testid={`table-grid-${r}-${c}`}
            />
          );
        })}
      </div>
      <button
        onClick={onClose}
        className="mt-2 w-full text-[10px] text-muted-foreground hover:text-foreground text-center py-0.5"
        data-testid="table-grid-cancel"
      >
        Cancel
      </button>
    </div>
  );
};
